import { useEffect, useState } from "react";

// Tracks whether `src` has actually finished downloading. A plain <img> swap leaves the
// previous image on screen until the new bytes arrive, which reads as "nothing happened" when
// switching between tabs/filters/years. Consumers use this to show a skeleton in that window
// instead of appearing stuck on the old selection.
const useImagePreload = (src) => {
  const [isLoading, setIsLoading] = useState(!!src);

  useEffect(() => {
    if (!src) {
      setIsLoading(false);
      return undefined;
    }

    let active = true;
    setIsLoading(true);

    const image = new Image();
    const finish = () => {
      if (active) setIsLoading(false);
    };
    image.onload = finish;
    image.onerror = finish;
    image.src = src;

    return () => {
      active = false;
    };
  }, [src]);

  return isLoading;
};

export default useImagePreload;
